// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__AzwJp","range":"MonthRangeSwitch_range__3FUcG","disabled":"MonthRangeSwitch_disabled__1Gcz-"};